import GrowthExecutiveHeroBanner from "./GrowthExecutiveHeroBanner";
// import GrowthExecutiveHero from "./GrowthExecutiveHero";
import MovingBorder from "./MovingBorder";
import GrowthExecutiveSlider from "./GrowthExecutiveSlider";

class VerticalGrowthExecutive {
    constructor() {
        // const mainHero = document.getElementById("growth-executive-hero");
        // if (mainHero) {
        //     const hero = new GrowthExecutiveHero(mainHero);
        // }

        const mainHeroBanner = document.getElementById("growth-executive-hero-wrapper");
        if (mainHeroBanner) {
            const heroBanner = new GrowthExecutiveHeroBanner(mainHeroBanner);
        }

        const movingBorders = document.querySelectorAll('[data-moving-border]')
        if (movingBorders.length) {
            movingBorders.forEach((movingBorder) => {
                new MovingBorder(movingBorder)
            })
        }

        this.onScroll = this.onScroll.bind(this);
        this.checkArticleInView = this.checkArticleInView.bind(this);

        this.ticking = false;
        this.articles = [...document.querySelectorAll('.eh--article')];
        if(this.articles.length) {
            window.addEventListener('scroll', this.onScroll);
            this.checkArticleInView();
        }

        const contributorsSliderEl = [...document.querySelectorAll('.eh-contributors-slider')];
        if(contributorsSliderEl.length) {
            contributorsSliderEl.forEach((el) => {
                new GrowthExecutiveSlider(el);
            })
        }
    }

    onScroll() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.checkArticleInView();
                this.ticking = false;
            });

            this.ticking = true;
        }
    }

    checkArticleInView() {
        const viewportHeight = window.innerHeight;
        const halfViewportHeight = viewportHeight / 2;
        let closest = null;

        // Loop through each article and find the one closest to the center
        this.articles.forEach(article => {
            const bounding = article.getBoundingClientRect();
            const offset = bounding.top + bounding.height / 2;
            const distance = Math.abs(halfViewportHeight - offset);

            if (closest === null || distance < closest.distance) {
                closest = { distance, element: article };
            }
        });

        // Remove 'active' class from all articles
        this.articles.forEach(article => article.classList.remove('active'));

        // Add 'active' class to the closest article
        if (closest) {
            closest.element.classList.add('active');
        }
    }
}

export default VerticalGrowthExecutive
